module.exports = __webpack_public_path__ + "img/icon_5@2x.9495227b.png";